export { HotCard } from './HotCard.pv';
export { HotCardComment } from './HotCard.comment';



// WEBPACK FOOTER //
// ./src/components/HomeTop/HotCard/index.ts